module.exports = __webpack_public_path__ + "img/empty@3x.5a0b226a.png";